import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProductionLoadChart } from "src/components/views/erp/production/productionPlanning/backlogChart/ProductionLoadChart.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/production/loadChart")({
	staticData: { title: i18n.t("production_load"), legacyViewKey: "productionLoadChartView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProductionLoadChart />;
}
